export const apiBaseUrl =
    import.meta.env.VITE_API_BASE_URL ?? "https://localhost:7050/api";